
















































































































































































































import {Vue, Component, Ref} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import {
  Collapse,
  DatePickerWings, InputWings,
  SelectWings,
  SpoilerWings,
  ToggleWings
} from 'wings-ui-components';
import {CollapseTransition} from 'vue2-transitions';
import {cloneDeep, isEqual} from "lodash";
import {PartnerItem, PartnerItemImpl} from '@/store/settings/partners/types';
import {notifyConfirm, notifyDelete, notifyError} from '@/utils/notify-helper';
import { TransportItem } from '@/store/transport/types';
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {
  SelectWings, DatePickerWings,
  ToggleWings, Collapse, SpoilerWings,
  CollapseTransition, InputWings
}})
export default class Partner extends Vue {

  @Ref('validator') validator: any;

  @Action('getTransports') actionGetTransports: any;
  @Action('getPartnerItem') actionGetItem: any;
  @Action('savePartner') actionSave: any;
  @Action('deletePartner') actionDelete: any;
  @Action("actionLog") actionLog: any;

  @Getter('transports') transportsList!: TransportItem[];

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {};

  defaultItem(): PartnerItem {
    return new PartnerItemImpl();
  }

  get transportNames(): string[] {
    return this.transportsList.map((t: TransportItem) => t.name);
  }

  created() {
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Client"
      }
      this.actionGetItem(this.$route.params.id).then((data: PartnerItem) => {
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.logObject.object_name = this.item.name;
        this.actionLog(this.logObject);
      }).catch(()=> {
        this.actionLog({...this.logObject, action_status: "failed"})
      });
    }
    this.actionGetTransports();
  }

  back(): void {
    this.$router.push('/settings/partners/');
  }

  async onSaveItem(): Promise<void> {
    if (this.item.transports?.length === 0) {
      setTimeout(() => {
        notifyError(null, ['Нужно указать хотя бы 1 активный транспорт'])
      }, 100);
      return
    }
    let valid:boolean = await this.validator.validate();
    if (valid) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "Client",
          object_name : this.item.name,
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
    }
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Client",
          object_name : this.item.name,
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete(this.item)
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  getTransportValue(id: number): boolean {
    return this.item.transports?.some(pti => pti.id === id) || false
  }

  setTransportValue(value: boolean, id: number) {
    if (value) {
      this.item.transports?.push({id: id, multisignature: false, template_only: false, on_moderation: false})
    } else {
      this.item.transports = this.item.transports?.filter((pti: any) => pti.id !== id)
    }
  }

  getMultisignature(id: number): boolean {
    return this.item.transports?.find(pti => pti.id === id)?.multisignature || false
  }

  setMultisignature(value: boolean, id: number) {
    this.item.transports?.filter(pti => pti.id === id).map(pti => pti.multisignature = value ?? false)
  }

  getTemplateOnly(id: number): boolean {
    return this.item.transports?.find(pti => pti.id === id)?.template_only || false
  }

  setTemplateOnly(value: boolean, id: number) {
    this.item.transports?.filter(pti => pti.id === id).map(pti => pti.template_only = pti.on_moderation = value ?? false)
  }

  getOnModeration(id: number): boolean {
    return this.item.transports?.find(pti => pti.id === id)?.on_moderation || false
  }

  setOnModeration(value: boolean, id: number) {
    this.item.transports?.filter(pti => pti.id === id).map(pti => pti.on_moderation = value ?? false)
  }

  get status():number {
    return this.item.status
  }

  set status(value:number) {
    this.item.status = (value ?? 0)
  }

  get prepaid():boolean {
    return this.item.prepaid
  }

  set prepaid(value:boolean) {
    this.item.prepaid = (value ?? false)
  }

  get smsTransportValue(): boolean {
    return this.getTransportValue(1)
  }

  set smsTransportValue(value: boolean) {
    this.setTransportValue(value, 1)
  }

  get smsMultisignature(): boolean {
    return this.getMultisignature(1)
  }

  set smsMultisignature(value: boolean) {
    this.setMultisignature(value, 1)
  }

  get smsTemplateOnly(): boolean {
    return this.getTemplateOnly(1)
  }

  set smsTemplateOnly(value: boolean) {
    this.setTemplateOnly(value, 1)
  }

  get smsOnModeration(): boolean {
    return this.getOnModeration(1)
  }

  set smsOnModeration(value: boolean) {
    this.setOnModeration(value, 1)
  }

  get callTransportValue(): boolean {
    return this.getTransportValue(2)
  }

  set callTransportValue(value: boolean) {
    this.setTransportValue(value, 2)
  }

  get callMultisignature(): boolean {
    return this.getMultisignature(2)
  }

  set callMultisignature(value: boolean) {
    this.setMultisignature(value, 2)
  }

  get callTemplateOnly(): boolean {
    return this.getTemplateOnly(2)
  }

  set callTemplateOnly(value: boolean) {
    this.setTemplateOnly(value, 2)
  }

  get callOnModeration(): boolean {
    return this.getOnModeration(2)
  }

  set callOnModeration(value: boolean) {
    this.setOnModeration(value, 2)
  }

  get emailTransportValue(): boolean {
    return this.getTransportValue(3)
  }

  set emailTransportValue(value: boolean) {
    this.setTransportValue(value, 3)
  }

  get emailMultisignature(): boolean {
    return this.getMultisignature(3)
  }

  set emailMultisignature(value: boolean) {
    this.setMultisignature(value, 3)
  }

  get emailTemplateOnly(): boolean {
    return this.getTemplateOnly(3)
  }

  set emailTemplateOnly(value: boolean) {
    this.setTemplateOnly(value, 3)
  }

  get emailOnModeration(): boolean {
    return this.getOnModeration(3)
  }

  set emailOnModeration(value: boolean) {
    this.setOnModeration(value, 3)
  }

  get pushTransportValue(): boolean {
    return this.getTransportValue(4)
  }

  set pushTransportValue(value: boolean) {
    this.setTransportValue(value, 4)
  }

  get pushOnModeration(): boolean {
    return this.getOnModeration(4)
  }

  set pushOnModeration(value: boolean) {
    this.setOnModeration(value, 4)
  }

  get pushTemplateOnly(): boolean {
    return this.getTemplateOnly(4)
  }

  set pushTemplateOnly(value: boolean) {
    this.setTemplateOnly(value, 4)
  }

  get viberTransportValue(): boolean {
    return this.getTransportValue(6)
  }

  set viberTransportValue(value: boolean) {
    this.setTransportValue(value, 6)
  }

  get viberMultisignature(): boolean {
    return this.getMultisignature(6)
  }

  set viberMultisignature(value: boolean) {
    this.setMultisignature(value, 6)
  }

  get viberTemplateOnly(): boolean {
    return this.getTemplateOnly(6)
  }

  set viberTemplateOnly(value: boolean) {
    this.setTemplateOnly(value, 6)
  }

  get viberOnModeration(): boolean {
    return this.getOnModeration(6)
  }

  set viberOnModeration(value: boolean) {
    this.setOnModeration(value, 6)
  }

  // WhatsApp
  get whatsappTransportValue(): boolean {
    return this.getTransportValue(7)
  }

  set whatsappTransportValue(value: boolean) {
    this.setTransportValue(value, 7)
  }

  get whatsappMultisignature(): boolean {
    return this.getMultisignature(7)
  }

  set whatsappMultisignature(value: boolean) {
    this.setMultisignature(value, 7)
  }

  get whatsappTemplateOnly(): boolean {
    return this.getTemplateOnly(7)
  }

  set whatsappTemplateOnly(value: boolean) {
    this.setTemplateOnly(value, 7)
  }

  get whatsappOnModeration(): boolean {
    return this.getOnModeration(7)
  }

  set whatsappOnModeration(value: boolean) {
    this.setOnModeration(value, 7)
  }

  // Custom
  get customTransportValue(): boolean {
    return this.getTransportValue(8)
  }

  set customTransportValue(value: boolean) {
    this.setTransportValue(value, 8)
  }

  get customMultisignature(): boolean {
    return this.getMultisignature(8)
  }

  set customMultisignature(value: boolean) {
    this.setMultisignature(value, 8)
  }

  get customTemplateOnly(): boolean {
    return this.getTemplateOnly(8)
  }

  set customTemplateOnly(value: boolean) {
    this.setTemplateOnly(value, 8)
  }

  get customOnModeration(): boolean {
    return this.getOnModeration(8)
  }

  set customOnModeration(value: boolean) {
    this.setOnModeration(value, 8)
  }

  // Mail Notify
  get mailNotifyTransportValue(): boolean {
    return this.getTransportValue(9)
  }

  set mailNotifyTransportValue(value: boolean) {
    this.setTransportValue(value, 9)
  }

  get mailNotifyTemplateOnly(): boolean {
    return this.getTemplateOnly(9)
  }

  set mailNotifyTemplateOnly(value: boolean) {
    this.setTemplateOnly(value, 9)
  }

  get mailNotifyOnModeration(): boolean {
    return this.getOnModeration(9)
  }

  set mailNotifyOnModeration(value: boolean) {
    this.setOnModeration(value, 9)
  }

  }
